import styled from "styled-components";

interface XrButtonCardMvProps {
  title: string;
  image: string;
  description: string;
  onClick: () => void;
}

const XrButtonCardMv = (props: XrButtonCardMvProps) => {
  return (
    <XrButtonCardMvWrapper onClick={props.onClick}>
      <div className='button__description'>
        <p className='button__description-title'>{props.title}</p>
        <p className='button__description-subtitle'>{props.description}</p>
      </div>
      <div className='button__image'>
        <img src={props.image} alt='' />
      </div>
    </XrButtonCardMvWrapper>
  );
}

const XrButtonCardMvWrapper = styled.div`
  width: 100%;
  display: flex;
  padding: 30px;
  cursor: pointer;
  border-radius: 5px;
  align-items: center;
  transition: 0.15s all;
  border: 1px solid #ECECEC;
  background-color: #FAFAFA;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.08);

  &:hover {
    border-color: #00AD8C;
  }

  & .button__description {
    width: (100% - 147px);
    margin-right: 15px;
    
    &-title {
      margin: 0;
      font-size: 16px;
      font-weight: bold;
      color: #00AD8C;
      margin-bottom: 5px;
    }
    &-description {
      margin: 0;
      font-size: 14px;
    }
  }

  & .button__image {
    width: 123px;
    min-width: 123px;

    & img {
      width: 100%;
    }
  }
`;

export default XrButtonCardMv;